import { SxProps, Theme } from "@mui/material";

export const loginFieldSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    minHeight: { xs: 60, sm: 64 },
    borderRadius: "12px",
    backgroundColor: "background.paper",
    fontSize: { xs: 17, sm: 18 },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "borderMuted",
      borderWidth: "1px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "inputChrome",
    },
    "&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
      borderColor: "nearBlack",
      borderWidth: "1.5px",
    },
  },
  "& .MuiInputBase-input": {
    paddingX: 2.25,
  },
  "& .MuiFormHelperText-root": {
    marginX: 0,
    marginTop: 1,
  },
};

export const loginPrimaryButtonSx: SxProps<Theme> = {
  width: "100%",
  minHeight: 56,
  borderRadius: "10px",
  fontSize: 16,
};

export const loginSecondaryButtonSx: SxProps<Theme> = {
  ...loginPrimaryButtonSx,
  borderColor: "borderMuted",
  color: "text.primary",
  backgroundColor: "background.paper",
  "&:hover": {
    borderColor: "inputChrome",
    backgroundColor: "surfaceMuted",
  },
};
